export { default } from "./EssayStep";

// Override addEventListener to make scroll-blocking events passive by default
const defaultAddEventListener = EventTarget.prototype.addEventListener;

EventTarget.prototype.addEventListener = function (type, listener, options) {
  if (
    type === "touchstart" ||
    type === "touchmove" ||
    type === "wheel"
  ) {
    if (typeof options === "object") {
      options.passive = true; // Set passive to true for scroll-blocking events
    } else {
      options = { passive: true };
    }
  }
  return defaultAddEventListener.call(this, type, listener, options);
};